import React, { createRef, useState } from 'react';
import PropTypes from 'prop-types';
import Api from '../../../services/ApiService';
import NoEmployeePhoto from '../../../img/no-photo-employee.png';
import './OneThumb.scss';

const ImageLoaderCachable = ({ imgUrl, alt }) => (
  <span className="round-img-wrapper">
    <img
      className="round-img"
      src={imgUrl && imgUrl !== '0' ? imgUrl : NoEmployeePhoto}
      alt={alt}
      title={alt}
    />
  </span>
);

ImageLoaderCachable.propTypes = {
  imgUrl: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

const UploadImagePlaceholder = (extraClasses = '') => (
  <span className="round-img-wrapper no-spinner">
    <img className={`upload-image-placeholder ${extraClasses}`} src="/img/upload-icon.svg" alt="upload" />
  </span>
);

const OneThumb = ({ model, changeable, endpoint }) => {
  const uploadRef = createRef();
  const defaultImage = changeable ? '/img/upload-icon.svg' : NoEmployeePhoto;
  const [imgName, setImgName] = useState(model?.avatar ?? defaultImage);
  const [isUploading, setIsUploading] = useState(false);

  const handleChange = (e) => {
    if (e.target.files.length === 0) {
      return;
    }
    setIsUploading(true);
    
    const file = e.target.files[0];
    const updatedData = new FormData();
    updatedData.append('avatar', file);
    updatedData.append('_method', 'patch');

    Api.post(`${endpoint}/${model.id}`, updatedData).then((res) => {
      setImgName(res?.data?.avatar);
      setIsUploading(false);
    });
  };

  const imgUrl = isUploading ? '/img/placeholder-thumb-spinner.png' : imgName;

  const Img = typeof imgName === 'undefined' || imgName === '' || imgName === null
    ? <UploadImagePlaceholder />
    : <ImageLoaderCachable model={model} endpoint={endpoint} imgUrl={imgUrl} alt="" />;

  return (
    <span className="one-thumb">
      {
        changeable
          ? (
            <>
              <input
                type="file"
                onChange={e => handleChange(e)}
                className="hidden-upload"
                ref={uploadRef}
              />
              <span onClick={() => uploadRef.current.click()}>{ Img }</span>
            </>
          )
          : Img
      }
    </span>
  );
};

OneThumb.propTypes = {
  model: PropTypes.shape({}).isRequired,
  endpoint: PropTypes.string.isRequired,
  changeable: PropTypes.bool,
};

OneThumb.defaultProps = {
  changeable: true,
};


export default OneThumb;